const { fetchWithRetry } = require('./utils'); 
//test

const createApplication = async (applicationData) => {
    try {
        const response = await fetchWithRetry('/api/applications', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(applicationData),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Error creating application: ${response.statusText} - ${errorData.error}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error creating application:', error);
        throw error;
    }
};

const createRound2GroupApplications = async (applicationData) => {  
    try {  
        const response = await fetchWithRetry('/api/applications/round2group', {  
            method: 'POST',  
            headers: {  
                'Content-Type': 'application/json',  
            },  
            body: JSON.stringify(applicationData),  
        });  
        if (!response.ok) {  
            const errorData = await response.json();  
            throw new Error(`Error creating round 2 group applications: ${response.statusText} - ${errorData.error}`);  
        }  
        return await response.json();  
    } catch (error) {  
        console.error('Error creating round 2 group applications:', error);  
        throw error;  
    }  
};  

const searchApplications = async (searchCriteria) => {
    try {
        const response = await fetchWithRetry('/api/applications/search', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(searchCriteria),
        });

        if (!response.ok) {
            throw new Error(`Error searching applications: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error searching applications:', error);
        throw error;
    }
};

const deleteApplication = async (applicationId) => {
    try {
        const response = await fetchWithRetry('/api/applications', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: applicationId }),
        });

        if (!response.ok) {
            throw new Error(`Error deleting application: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error deleting application:', error);
        throw error;
    }
};

const getApplicationsByContestant = async (contestantId, idNumber) => {
    try {
        const response = await fetchWithRetry('/api/applications/searchByContestant', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ contestant: contestantId, id_number: idNumber }),
        });

        if (response.status === 404) {
            return [];
        }

        if (!response.ok) {
            throw new Error(`Error fetching applications by contestant: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching applications by contestant:', error);
        throw error;
    }
};

const getApplicationsByContestants = async (contestantIds) => {  
    try {  
        const response = await fetchWithRetry('/api/applications/searchByContestants', {  
            method: 'POST',  
            headers: {  
                'Content-Type': 'application/json',  
            },  
            body: JSON.stringify({ contestants: contestantIds }),  
        });  
  
        if (response.status === 404) {  
            return [];  
        }  
  
        if (!response.ok) {  
            throw new Error(`Error fetching applications by contestants: ${response.statusText}`);  
        }  
  
        return await response.json();  
    } catch (error) {  
        console.error('Error fetching applications by contestants:', error);  
        throw error;  
    }  
};  

const getApplicationsByGroup = async (groupId) => {
    try {
        const response = await fetchWithRetry(`/api/applications/group/${groupId}`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.status === 404) {
            return [];
        }

        if (!response.ok) {
            throw new Error(`Error fetching applications by group ID: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching applications by group ID:', error);
        throw error;
    }
};

const getApplicationsByGroups = async (groupIds) => {
    try {
        const response = await fetchWithRetry(`/api/applications/searchByGroups`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ groups: groupIds }),
        });

        if (response.status === 404) {
            return [];
        }

        if (!response.ok) {
            throw new Error(`Error fetching applications by group ID: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching applications by group ID:', error);
        throw error;
    }
};

const updateApplicationPaidStatus = async (applicationId, newPaidStatus) => {
    try {
        const response = await fetchWithRetry(`/api/applications/${applicationId}/paid`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ paid: newPaidStatus }),
        });

        if (!response.ok) {
            throw new Error('Failed to update application paid status');
        }

        return await response.json();
    } catch (error) {
        console.error('Error updating application paid status:', error);
        throw error;
    }
};

const updateApplicationRound = async (applicationId) => {
    try {
        const response = await fetchWithRetry(`/api/applications/duplicate/${applicationId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Error duplicating application: ${response.statusText} - ${errorData.error}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error duplicating application:', error);
        throw error;
    }
};

const updateApplicationRounds = async (applicationIds) => {
    try {
        const response = await fetchWithRetry(`/api/applications/duplicate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ applicationIds }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Error duplicating applications: ${response.statusText} - ${errorData.error}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error duplicating applications:', error);
        throw error;
    }
};

const fetchStats = async () => {
    try {
        const response = await fetchWithRetry('/api/applications/stats', {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error fetching stats: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching stats:', error);
        throw error;
    }
};

const fetchApplicationsTimeline = async (startDate, endDate) => {
    try {
        let query = '/api/applications/timeline?';

        if (startDate) {
            query += `startDate=${encodeURIComponent(startDate)}&`;
        }

        if (endDate) {
            query += `endDate=${encodeURIComponent(endDate)}&`;
        }

        query = query.slice(0, -1);

        const response = await fetchWithRetry(query, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error fetching applications timeline: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching applications timeline:', error);
        throw error;
    }
};

const getApplicationsByEvent = async (eventId) => {
    try {
        const response = await fetchWithRetry(`/api/applications/event/${eventId}`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.status === 404) {
            return [];
        }

        if (!response.ok) {
            throw new Error(`Error fetching applications by event ID: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching applications by event ID:', error);
        throw error;
    }
};

const getApplicationsByVenue = async (venueId, round) => {
    try {
        const response = await fetchWithRetry(`/api/applications/venue/${venueId}/round/${round}`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.status === 404) {
            return [];  
        }

        if (!response.ok) {
            throw new Error(`Error fetching applications by venue ID and round: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching applications by venue ID and round:', error);
        throw error;
    }
};

const getAllApplications = async (round) => {
    try {
        const response = await fetchWithRetry(`/api/applications/venues/round/${round}`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.status === 404) {
            return [];   
        }

        if (!response.ok) {
            throw new Error(`Error fetching all applications by round: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching all applications by round:', error);
        throw error;
    }
};

const addDatesToApplications = async (applicationIds, date) => {
    try {
        const response = await fetchWithRetry('/api/applications/add-dates', {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ applicationIds, date }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Error adding dates to applications: ${response.statusText} - ${errorData.error}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error adding dates to applications:', error);
        throw error;
    }
};

const updateApplicationsWithScheduledTimes = async (applicationUpdates) => {
    try {
        const response = await fetchWithRetry('/api/applications/update-scheduled-times', {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ applicationUpdates }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Error updating applications: ${response.statusText} - ${errorData.error}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error updating applications:', error);
        throw error;
    }
};

const addGradeToApplication = async (applicationId, gradeData) => {
    try {
        const response = await fetchWithRetry(`/api/applications/${applicationId}/grades`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(gradeData),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Error adding grade to application: ${response.statusText} - ${errorData.error}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error adding grade to application:', error);
        throw error;
    }
};

const changeApplicationEvent = async (applicationId, newEventId) => {  
    try {  
        const response = await fetchWithRetry(`/api/applications/${applicationId}/change-event`, {  
            method: 'PUT',  
            headers: {  
                'Content-Type': 'application/json',  
            },  
            body: JSON.stringify({ event: newEventId }),  
        });  
  
        if (!response.ok) {  
            const errorData = await response.json();  
            throw new Error(`Error changing application event: ${response.statusText} - ${errorData.error}`);  
        }  
  
        return await response.json();  
    } catch (error) {  
        console.error('Error changing application event:', error);  
        throw error;  
    }  
};

module.exports = {
    createApplication,
    searchApplications,
    deleteApplication,
    getApplicationsByContestant,
    getApplicationsByGroup,
    updateApplicationPaidStatus,
    updateApplicationRound,
    updateApplicationRounds,
    fetchApplicationsTimeline,
    fetchStats,
    getApplicationsByEvent,
    getApplicationsByVenue,
    getAllApplications,
    addDatesToApplications,
    updateApplicationsWithScheduledTimes,
    addGradeToApplication,
    getApplicationsByContestants,
    changeApplicationEvent,
    getApplicationsByGroups,
    createRound2GroupApplications
};  